export default [{
  path: 'pregao-botoes/:id',
  name: 'pregaobotoes',
  component: () => import('./Main.vue')
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-botoes/routes.js